import { useEffect, useRef, useState } from 'react';

/* coming_soon_popups_28oct2026 (CEO mockup coming_soon_popups.html):
   four tappable Coming soon cards; each opens a full information pop-up
   OVER Home (no navigation) with Listen/Pause/Stop, six feature tiles,
   previous/next and a gold Done. Back gesture only closes the pop-up. */

const CARDS = [
  { key: 'booking', title: 'Booking system',
    img: 'https://customer-assets-agu9un31.emergentagent.net/job_distribution-pro-1/artifacts/51dc38d4da612975_IMG_3875.png',
    line: 'Your diary, client records, consultation forms, reminders and card payments in one place. Free for Revitalise Partners.',
    features: [
      ['📅', 'Diary for every stylist', 'Day, week and month views, colour-coded by treatment.'],
      ['🌐', 'Online booking day and night', 'Clients book themselves in a few taps, even when you are closed.'],
      ['🗂️', 'Client record cards', 'Consultation forms, history, photos and the products used on each visit.'],
      ['💬', 'Automatic reminders', 'Text, WhatsApp and email reminders that cut no-shows.'],
      ['💳', 'Deposits and card payments', 'Take a deposit when they book and payment at the desk.'],
      ['✅', 'One-tap check-in', 'The appointment changes colour and the stylist is told the client has arrived.'],
    ] },
  { key: 'hairmiles', title: 'Hair Miles',
    img: 'https://customer-assets-agu9un31.emergentagent.net/job_distribution-pro-1/artifacts/4113061df0be4297_IMG_3876.png',
    line: 'Earn points on every order and course, and swap them for professional tools and rewards.',
    features: [
      ['🛍️', 'Miles on every order', 'Every order earns miles for your salon automatically.'],
      ['🎓', 'Miles on every course', 'Finish Academy courses and earn more.'],
      ['🥉', 'Four levels', 'Bronze, Silver, Gold and Platinum, with better rewards at each level.'],
      ['🎁', 'Swap for tools', 'Use your miles on professional tools such as straightening irons.'],
      ['⭐', 'Extra miles for reviews', 'Review Revitalise and enter the best-review competition.'],
      ['🚚', 'Member perks', 'Early access to deals, free UK delivery and a free masterclass place at the top levels.'],
    ] },
  { key: 'findasalon', title: 'Find a salon',
    img: 'https://customer-assets-agu9un31.emergentagent.net/job_distribution-pro-1/artifacts/f6980aa53822f3a3_IMG_3874.png',
    line: 'Clients find your salon on our map and book you directly.',
    features: [
      ['🗺️', 'On the map', 'Your salon shows on the Revitalise map in London, Lagos and beyond.'],
      ['🔎', 'Found by treatment', 'Clients search by city and treatment, such as keratin, silk press or colour.'],
      ['🏅', 'Certified badge', 'Academy certificates show clients you are trained in the Revitalise method.'],
      ['⭐', 'Reviews', 'Your best reviews help new clients choose you.'],
      ['📲', 'Book you directly', 'Clients go straight into your booking diary.'],
      ['👤', 'Salons and professionals', 'Chair renters and independents can be found too.'],
    ] },
  { key: 'deals', title: 'Deals and courses',
    img: 'https://customer-assets-agu9un31.emergentagent.net/job_distribution-pro-1/artifacts/9bb7efd6f95fb261_IMG_3873.png',
    line: 'Monthly salon deals and booked training for your team.',
    features: [
      ['🏷️', 'Monthly deals', 'Offers for Revitalise salons only, claimed in one tap.'],
      ['📦', 'Added to your order', 'Claimed deals go straight into your next order.'],
      ['👩‍🎓', 'Book your team on training', 'Pick a course, choose who goes and book their places.'],
      ['🏫', 'In salon or at the Academy', 'Courses run in salon, at Hair 305 or live online.'],
      ['📜', 'Certificates', 'Your team earns certificates as they complete each course.'],
      ['🔔', 'Never miss one', 'You are told when a new deal or course goes live.'],
    ] },
];

const PLUM = '#291525';
const GOLD = '#B99A65';

function speakCard(card) {
  const u = new SpeechSynthesisUtterance(
    `${card.title}. Coming soon. ${card.line}. ` +
    card.features.map((f) => `${f[1]}. ${f[2]}`).join(' '));
  u.lang = 'en-GB';
  const v = window.speechSynthesis.getVoices().find((x) => x.lang === 'en-GB');
  if (v) u.voice = v;
  window.speechSynthesis.cancel();
  window.speechSynthesis.speak(u);
}

export const ComingSoonCards = () => {
  const [openIdx, setOpenIdx] = useState(null);
  const pushedRef = useRef(false);

  const close = () => {
    window.speechSynthesis?.cancel();
    setOpenIdx(null);
    if (pushedRef.current) {
      pushedRef.current = false;
      window.history.back();
    }
  };

  const openCard = (i) => {
    setOpenIdx(i);
    // back gesture closes the pop-up only, never leaves Home
    window.history.pushState({ rvkComingSoon: true }, '');
    pushedRef.current = true;
  };

  useEffect(() => {
    if (openIdx === null) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') close(); };
    const onPop = () => { pushedRef.current = false; window.speechSynthesis?.cancel(); setOpenIdx(null); };
    window.addEventListener('keydown', onKey);
    window.addEventListener('popstate', onPop);
    // exact-scroll lock: freeze Home at its position, restore on close
    const y = window.scrollY;
    const b = document.body.style;
    const prev = { position: b.position, top: b.top, width: b.width };
    b.position = 'fixed'; b.top = `-${y}px`; b.width = '100%';
    return () => {
      window.removeEventListener('keydown', onKey);
      window.removeEventListener('popstate', onPop);
      b.position = prev.position; b.top = prev.top; b.width = prev.width;
      window.scrollTo(0, y);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openIdx]);

  const card = openIdx !== null ? CARDS[openIdx] : null;

  return (
    <section data-testid="coming-soon-section" className="coming-soon-clearance" style={{ marginTop: 26 }}>
      <p style={{ fontSize: 12, letterSpacing: '2.5px', fontWeight: 700, color: '#7E5F2E', textTransform: 'uppercase', margin: 0 }}>Coming soon</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(230px, 1fr))', gap: 14, marginTop: 12 }}>
        {CARDS.map((c, i) => (
          <button key={c.key} type="button" data-testid={`coming-soon-${c.key}`}
            aria-label={`See what is coming in ${c.title}`}
            onClick={() => openCard(i)} className="rvk-soon-card"
            style={{ borderRadius: 24, overflow: 'hidden', background: PLUM, color: '#F8F4F1',
              display: 'flex', flexDirection: 'column', border: '1px solid transparent',
              textAlign: 'left', padding: 0, cursor: 'pointer' }}>
            <img src={c.img} alt={c.title} loading="lazy"
              style={{ width: '100%', height: 140, objectFit: 'cover', display: 'block' }} />
            <div style={{ padding: '10px 14px 14px' }}>
              <span style={{ fontSize: 9, letterSpacing: '2px', fontWeight: 700, color: '#2B1F27', background: GOLD, borderRadius: 999, padding: '3px 9px', textTransform: 'uppercase' }}>Coming soon</span>
              <h3 style={{ fontFamily: "'Bodoni Moda', Georgia, serif", fontWeight: 400, fontSize: 18, margin: '8px 0 4px', color: '#FBF7F0' }}>{c.title}</h3>
              <p style={{ fontSize: 12.5, lineHeight: 1.5, color: 'rgba(248,244,241,.75)', margin: 0 }}>{c.line}</p>
              <p style={{ fontSize: 12, color: '#D9BE8E', margin: '10px 0 0', letterSpacing: '.5px' }}>See what&rsquo;s coming &rarr;</p>
            </div>
          </button>
        ))}
      </div>

      {card && (
        <div data-testid="coming-soon-popup-backdrop" onClick={close}
          style={{ position: 'fixed', inset: 0, zIndex: 90, background: 'rgba(43,22,39,.55)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div role="dialog" aria-modal="true" aria-label={card.title} data-testid="coming-soon-popup"
            onClick={(e) => e.stopPropagation()} className="rvk-soon-popup"
            style={{ background: '#F8F4F1', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <div style={{ background: PLUM, color: '#F8F4F1', display: 'flex', alignItems: 'center', gap: 8, padding: '10px 12px', flexShrink: 0, flexWrap: 'wrap' }}>
              <button type="button" data-testid="popup-back-home" onClick={close}
                style={{ background: 'transparent', border: 0, color: '#D9BE8E', fontSize: 13, cursor: 'pointer', padding: '8px 6px' }}>&lsaquo; Back to Home</button>
              <span style={{ flex: 1 }} />
              <button type="button" data-testid="popup-listen" onClick={() => speakCard(card)}
                style={{ background: 'transparent', border: `1px solid ${GOLD}`, color: '#D9BE8E', borderRadius: 999, fontSize: 12, padding: '6px 12px', cursor: 'pointer' }}>Listen</button>
              <button type="button" data-testid="popup-pause" onClick={() => {
                const s = window.speechSynthesis;
                if (s.paused) s.resume(); else s.pause();
              }}
                style={{ background: 'transparent', border: `1px solid ${GOLD}`, color: '#D9BE8E', borderRadius: 999, fontSize: 12, padding: '6px 12px', cursor: 'pointer' }}>Pause</button>
              <button type="button" data-testid="popup-stop" onClick={() => window.speechSynthesis?.cancel()}
                style={{ background: 'transparent', border: `1px solid ${GOLD}`, color: '#D9BE8E', borderRadius: 999, fontSize: 12, padding: '6px 12px', cursor: 'pointer' }}>Stop</button>
              <button type="button" aria-label="Close" data-testid="popup-close" onClick={close}
                style={{ background: 'transparent', border: 0, color: '#F8F4F1', fontSize: 15, cursor: 'pointer', padding: '8px 10px' }}>&#10005; Close</button>
            </div>
            <div style={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch' }}>
              <img src={card.img} alt={`Preview of ${card.title}`}
                style={{ width: '100%', maxHeight: 300, objectFit: 'cover', objectPosition: 'top', display: 'block' }} />
              <div style={{ padding: '18px 20px 24px' }}>
                <span style={{ fontSize: 10, letterSpacing: '2px', fontWeight: 700, color: '#2B1F27', background: GOLD, borderRadius: 999, padding: '4px 11px', textTransform: 'uppercase' }}>Coming soon</span>
                <h2 style={{ fontFamily: "'Bodoni Moda', Georgia, serif", fontWeight: 400, fontSize: 30, margin: '12px 0 8px', color: '#2B1F27' }}>{card.title}</h2>
                <p style={{ fontFamily: 'Lexend, sans-serif', fontSize: 14.5, lineHeight: 1.6, color: '#64525D', margin: '0 0 18px' }}>{card.line}</p>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(230px, 1fr))', gap: 12 }}>
                  {card.features.map((f) => (
                    <div key={f[1]} data-testid="popup-feature-tile"
                      style={{ border: '1px solid rgba(185,154,101,.45)', borderRadius: 14, padding: '14px 14px', background: '#FFFFFF' }}>
                      <div style={{ fontSize: 20 }}>{f[0]}</div>
                      <div style={{ fontFamily: 'Lexend, sans-serif', fontWeight: 600, fontSize: 13.5, color: '#2B1F27', margin: '6px 0 3px' }}>{f[1]}</div>
                      <div style={{ fontFamily: 'Lexend, sans-serif', fontSize: 12.5, lineHeight: 1.5, color: '#64525D' }}>{f[2]}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div style={{ flexShrink: 0, borderTop: '1px solid #E8DDD5', background: '#F8F4F1', display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px calc(10px + env(safe-area-inset-bottom, 0px))' }}>
              <button type="button" data-testid="popup-prev" onClick={() => { window.speechSynthesis?.cancel(); setOpenIdx((openIdx + CARDS.length - 1) % CARDS.length); }}
                style={{ background: 'transparent', border: 0, color: '#7A3E22', fontSize: 13, cursor: 'pointer', padding: 8 }}>&lsaquo; previous feature</button>
              <span style={{ flex: 1, textAlign: 'center' }}>
                {CARDS.map((c, i) => (
                  <span key={c.key} style={{ display: 'inline-block', width: 8, height: 8, borderRadius: 999, margin: '0 3px', background: i === openIdx ? GOLD : '#D9CFC5' }} />
                ))}
              </span>
              <button type="button" data-testid="popup-next" onClick={() => { window.speechSynthesis?.cancel(); setOpenIdx((openIdx + 1) % CARDS.length); }}
                style={{ background: 'transparent', border: 0, color: '#7A3E22', fontSize: 13, cursor: 'pointer', padding: 8 }}>next feature &rsaquo;</button>
              <button type="button" data-testid="popup-done" onClick={close}
                style={{ background: GOLD, border: 0, color: PLUM, fontWeight: 700, fontSize: 13, letterSpacing: '1px', borderRadius: 999, padding: '10px 22px', cursor: 'pointer' }}>&#10003; Done</button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
